import React from 'react'
import { cn } from '../../utils/cn'

const LoadingSpinner = ({ 
  size = 'md', 
  className = '', 
  color = 'primary',
  text = null 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  }

  const colorClasses = {
    primary: 'border-primary-600',
    accent: 'border-accent-600',
    white: 'border-white',
    neutral: 'border-neutral-600',
  }

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="flex flex-col items-center space-y-2">
        <div
          className={cn(
            'border-2 border-neutral-200 dark:border-neutral-700 border-t-current rounded-full animate-spin',
            sizeClasses[size],
            colorClasses[color]
          )}
        />
        {text && (
          <p className="text-sm text-neutral-600 dark:text-neutral-400">
            {text}
          </p>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner